(() => {
  const hostSelector = '.additional-checkout-buttons shopify-accelerated-checkout-cart';
  const wrapperSelector = '.additional-checkout-buttons .dynamic-checkout__content';
  let checkoutObserver;

  function constrainAcceleratedCheckout() {
    const host = document.querySelector(hostSelector);
    if (!host) return;

    const shopPay =
      host.querySelector('shop-pay-wallet-button[slot="button-ShopPay"]') ||
      host.querySelector('shop-pay-wallet-button');

    if (!shopPay) return;

    host
      .querySelectorAll(
        'shopify-paypal-button, shopify-google-pay-button, apple-pay-wallet-button,' +
          '[slot="button-PayPal"], [slot="button-GooglePay"], [slot="button-ApplePay"]'
      )
      .forEach((element) => {
        element.style.display = 'none';
      });

    const height = Math.round(shopPay.getBoundingClientRect().height) || 54;
    if (host.dataset.acbHeight === String(height)) return;

    checkoutObserver?.disconnect();
    host.style.maxHeight = `${height}px`;
    host.style.overflow = 'hidden';
    host.dataset.acbHeight = String(height);

    const wrapper = document.querySelector(wrapperSelector) || host.parentElement;
    if (wrapper) {
      wrapper.style.maxHeight = `${height}px`;
      wrapper.style.overflow = 'hidden';
    }

    observeAcceleratedCheckout();
  }

  function observeAcceleratedCheckout() {
    const container = document.querySelector('.additional-checkout-buttons');
    if (!container) return;

    checkoutObserver?.disconnect();
    checkoutObserver = new MutationObserver(() => {
      requestAnimationFrame(constrainAcceleratedCheckout);
    });
    checkoutObserver.observe(container, { childList: true, subtree: true });
  }

  function initializeAcceleratedCheckout() {
    observeAcceleratedCheckout();
    [0, 150, 400, 1000, 2000].forEach((delay) => {
      window.setTimeout(constrainAcceleratedCheckout, delay);
    });
  }

  document.addEventListener('DOMContentLoaded', initializeAcceleratedCheckout);
  document.addEventListener('cart-drawer:refreshed', initializeAcceleratedCheckout);
  window.addEventListener('resize', () => requestAnimationFrame(constrainAcceleratedCheckout));
})();
